module.exports = __webpack_public_path__ + "static/media/55_000056.a89c435c.jpg";